export default () => {
    const getWindowLocationDefaultFetchBase = (): string => {
        return `${window.location.protocol}//${window.location.host}`;
    }

    const getTNEWSharedSessionUrl = (fetchBase: string): string => {
        if (fetchBase == null || fetchBase === "") {
            fetchBase = getWindowLocationDefaultFetchBase();
        }
        console.group("getTNEWRedirectUrl");
        let tnewbase = window.tnewUrl;
        console.log("TNEW BASE: ", tnewbase);

        const sharedSessionParams = new URLSearchParams();
        const sharedSessionActionUrl = `${fetchBase}/api/tessitura/setsession`;
        console.log("Shared Session - Action URL: ", sharedSessionActionUrl);
        sharedSessionParams.append("actionUrl", sharedSessionActionUrl);
        const sharedSessionReturnUrl = window.location.href;
        console.log("Shared Session - Return URL: ", sharedSessionReturnUrl);
        sharedSessionParams.append("returnUrl", window.location.href);

        console.log("Shared Session Params");
        console.log(sharedSessionParams);

        return `${tnewbase}/components/sharedsession?${sharedSessionParams.toString()}`;
    }

    const getTNEWRedirectUrl = (fetchBase: string): string => {
        let tnewbase = window.tnewUrl;

        const redirectParams = new URLSearchParams();
        const redirectRedirectUrl = getTNEWSharedSessionUrl(fetchBase);
        redirectParams.append("returnurl", redirectRedirectUrl);
        console.log("Redirect URL: ", redirectRedirectUrl);

        console.log("Redirect Params");
        console.log(redirectParams);

        const finalUrl = `${tnewbase}/account/login?${redirectParams.toString()}`;
        console.log("finalUrl", finalUrl);

        return finalUrl;
    }

    const redirectTNewLogin = (fetchBase: string): void => {
        const redirectUrl = getTNEWRedirectUrl(fetchBase);
        (window.top ?? window).location.href = redirectUrl;
    }

    const redirectTNewSharedSession = (fetchBase: string): void => {
        const redirectUrl = getTNEWSharedSessionUrl(fetchBase);
        (window.top ?? window).location.href = redirectUrl;
    }

    return { redirectTNewLogin, redirectTNewSharedSession };
}